module.exports = __webpack_public_path__ + "img/Kraftfahrzeug.aa944a77.svg";